<template>
	<section class="page">
		<h3>普通用户管理</h3>

		<div class="content-box">
			<div class="operator">
				<div class="operator-col">
					<el-button size="mini" type="primary" @click="handleCreate()" v-loading="loadings.create">新建</el-button>
				</div>
				<div class="operator-col">
					<el-input
						size="mini"
						v-model="filterTableSearch"
						placeholder="姓名/手机号"
						suffix-icon="el-icon-search"
						clearable
					></el-input>
				</div>
			</div>
			<curd-table
				ref="listTable"
				:data-model="editorDataModel"
				:fields="tableFields"
				:search-filter="filterTableSearch"
				:kv-filter="kvFilter"
				:list-ops="listOps"
				@goaddress="handlerGoAddress($event)"
				@doedit="handleEdit($event)"
			></curd-table>
		</div>
		<editor
			:show.sync="editorVisible"
			:data-model-name="editorDataModel"
			:record-id="editorId"
			:fields="editorFields"
			@change="refreshTable('listTable')"
		></editor>
	</section>
</template>

<script>
import Charge from "@/views/Customer/subs/Charge.vue";
import CurdPage from "@/mixins/CurdPage.js";
import Filters from "@/mixins/Filters.js";
import TabPage from "@/mixins/TabPage.js";

export default {
	mixins: [CurdPage, Filters, TabPage],
	data() {
		return {
			editorDataModel: "User",
			filterTableSearch: "",
			filterVip_level: { field: "vip_level", index: null },
			tableFields: [
				{
					name: "name",
					sortable: "custom",
				},
				{
					name: "nickname",
					sortable: "custom",
				},
				{
					name: "phone",
					sortable: "custom",
				},
				{
					name: "reg_ts",
					sortable: "custom",
				},
				{
					name: "vip_level",
					sortable: "custom",
				},
			],
			editorFields: [
				{
					name: "name",
					col: 6,
					rules: ["required"],
				},
				{
					name: "nickname",
					col: 12,
				},
				{
					name: "vip_level",
					col: 6,
				},
				{
					name: "is_baned",
					col: 6,
				},
				{
					name: "is_admin",
					col: 6,
				},
			],
			listOps: [
				{
					name: "edit",
					show_name: "编辑",
					handler: "doedit",
				},
				{
					name: "editAddress",
					show_name: "详情",
					handler: "goaddress",
				},
			],
		};
	},
	computed: {},
	created() {},
	mounted() {
		this.refreshRoute();
	},
	methods: {
		refreshRoute(tab = null) {
			if (!tab) {
				this.activeName = this.$route.params.tab;
			} else {
				this.activeName = tab;
			}
		},
		handlerGoAddress(id) {
			this.$router.push({
				name: "Customer-User-Show",
				params: {
					id: id,
				},
			});
		},
	},
	watch: {
		// 如果路由有变化，会再次执行该方法
		$route: {
			handler(val) {
				if (val) {
					this.refreshRoute();
				}
			},
			immediate: true,
			deep: true,
		},
		"filterVip_level.value": {
			handler(newVal) {
				let val = this.filterVip_level;
				if (val.value != null && val.value !== "") {
					this.$set(this.kvFilter, val.field, { k: val.field, t: "int", v: val.value });
				} else {
					this.$delete(this.kvFilter, val.field);
				}
			},
			immediate: true,
		},
	},
};
</script>
<style lang="scss" scoped>
</style>
